import React, { ReactNode } from 'react';
import NextLink, { LinkProps } from 'next/link';
import useExperiment from '~/lib/experiment';

const URL_WHITELIST_PREFIX: Array<string> = ['/asksumo/'];

export function Link({
  children,
  href,
  target = '_self',
  ...props
}: {
  children?: ReactNode;
  href: string;
  target?: '_self' | '_blank';
} & (React.HTMLAttributes<HTMLAnchorElement> | LinkProps)) {
  const whitelistPrefix: Array<string> = [...URL_WHITELIST_PREFIX];
  const whitelistExact: Array<string> = [];

  const { variant: isNextBrowse } = useExperiment('next-browse');
  const { variant: isNextHome } = useExperiment('next-home');
  const { variant: isNextCollections } = useExperiment('next-collections');
  const { variant: isNextPDP } = useExperiment('next-pdp');

  if (isNextBrowse === 'enabled') {
    whitelistPrefix.push('/browse');
    whitelistPrefix.push('/search');
    whitelistPrefix.push('/software');
    whitelistPrefix.push('/creative-resources');
    whitelistPrefix.push('/templates');
    whitelistPrefix.push('/courses-learning');
  }

  if (isNextCollections === 'enabled') {
    whitelistPrefix.push('/collections');
  }

  if (isNextPDP === 'enabled') {
    whitelistPrefix.push('/products');
  }

  if (isNextHome === 'enabled') {
    whitelistExact.push('/');
  }

  if (!href) {
    return <></>;
  }

  // if link is whitelisted use next/link to render the a tag
  if (
    target === '_self' &&
    (whitelistExact.some((url) => href === url) ||
      whitelistPrefix.some((url) => href.startsWith(url)))
  ) {
    return (
      <NextLink href={href} {...props}>
        {children}
      </NextLink>
    );
  }

  return (
    <a href={href} target={target} {...props}>
      {children}
    </a>
  );
}
